var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nh-item-type"},_vm._l((_vm.types),function(type){return _c('span',{key:type.symbol,staticClass:"nh-item-symbol",style:('color: ' + type.color + ';'),attrs:{"title":type.notes},on:{"click":function($event){return _vm.$emit('clicked', type.notes)}}},[_vm._v(" "+_vm._s(type.symbol)+"  ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }